import { useState } from 'react';

import type { SurveyGuestToken, SurveyResponseRecord, SurveyTemplate } from '../domain-types';

export function useSurveys() {
  const [surveyAudience, setSurveyAudience] = useState('');
  const [surveyConsentStatement, setSurveyConsentStatement] = useState(
    'By submitting this survey, you consent to quality.vet recording your anonymous responses for quality-improvement purposes.',
  );
  const [surveyQuestions, setSurveyQuestions] = useState('');
  const [surveyTemplates, setSurveyTemplates] = useState<SurveyTemplate[]>([]);
  const [surveyTemplateName, setSurveyTemplateName] = useState('');
  const [surveyShareLink, setSurveyShareLink] = useState('');
  const [surveyShareToken, setSurveyShareToken] = useState('');
  const [surveyLinks, setSurveyLinks] = useState<Record<string, SurveyGuestToken[] | undefined>>(
    {},
  );
  const [surveyResults, setSurveyResults] = useState<{
    title: string;
    questions: string[];
    items: SurveyResponseRecord[];
  } | null>(null);

  return {
    surveyAudience,
    setSurveyAudience,
    surveyConsentStatement,
    setSurveyConsentStatement,
    surveyQuestions,
    setSurveyQuestions,
    surveyTemplates,
    setSurveyTemplates,
    surveyTemplateName,
    setSurveyTemplateName,
    surveyShareLink,
    setSurveyShareLink,
    surveyShareToken,
    setSurveyShareToken,
    surveyLinks,
    setSurveyLinks,
    surveyResults,
    setSurveyResults,
  };
}
